/* eslint-disable @typescript-eslint/no-namespace */

import {
  array,
  literal,
  nullable,
  number,
  object,
  omit,
  partial,
  string,
  union,
  type Infer,
} from "superstruct";

export namespace Greathelm {
  export type Ref = Infer<ReturnType<typeof ref>>;

  export type KnightData = Infer<ReturnType<typeof knightData>>;

  export type WarbandData = Infer<ReturnType<typeof warbandData>>;

  export type WarbandSnapshotData = Infer<
    ReturnType<typeof warbandSnapshotData>
  >;

  export type Tombstone = Infer<ReturnType<typeof tombstone>>;

  export type GameDataGroups = Infer<ReturnType<typeof gameDataGroups>>;
}

export function ref() {
  return object({ id: string() });
}

export function knightData() {
  return object({
    id: string(),
    name: string(),
    profile: ref(),
    weapons: array(ref()),
    shields: array(ref()),
    armor: ref(),
    wearables: array(ref()),
    items: array(ref()),
    upgrades: array(ref()),
    count: number(),
  });
}

export function gameDataGroups() {
  return partial({
    warbands: array(union([warbandData(), tombstone()])),
  });
}

export function warbandData() {
  return object({
    id: string(),
    name: string(),
    rulesetVersion: string(),
    snapshotId: nullable(string()),
    knights: array(knightData()),
    createdTs: number(),
    updatedTs: number(),
    deleted: literal(false),
  });
}

export function warbandSnapshotData() {
  return omit(warbandData(), ["snapshotId", "deleted"]);
}

export function tombstone() {
  return object({
    id: string(),
    name: string(),
    updatedTs: number(),
    deleted: literal(true),
  });
}
